import { render } from "./subsidies.vue?vue&type=template&id=5b6ab42e&scoped=true"
import script from "./subsidies.vue?vue&type=script&lang=js"
export * from "./subsidies.vue?vue&type=script&lang=js"

import "./subsidies.vue?vue&type=style&index=0&id=5b6ab42e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6ab42e"]])

export default __exports__